// extracted by mini-css-extract-plugin
export default {"header":"_7eMh8","title":"DS1H7n","smallText":"r8JNdn","searchFadeIn":"hxZvdD"};